import styled from 'styled-components/native';

export const Container = styled.TouchableOpacity`
    margin: 10px;
`;
